import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext, RicosViewerContext } from "./../../../../../ricos-context";
import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import { getLinkHrefUrl } from "./../../../../../_shared/link/get-link-href-url";
import {
  addAnchorTagToUrl,
  anchorScroll,
  convertRelObjectToString
} from "./../../../../../wix-rich-content-common";
import classes from "./link-viewer-wrapper.rtlignore-scss";
const LinkViewerWrapper = ({
  children,
  nodeType,
  link
}) => {
  const { anchorTarget, baseUrl, customAnchorScroll } = useContext(RicosViewerContext);
  const { tabIndex } = useContext(RicosContext);
  if (!(link && nodeType !== Node_Type.BUTTON)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      className: classNames(classes.link, "has-custom-focus", {
        [classes.anchor]: link
      }),
      tabIndex,
      href: link ? getLinkHrefUrl(link, baseUrl) : void 0,
      target: link.target ? `_${link.target.toLowerCase()}` : anchorTarget,
      rel: link.rel && convertRelObjectToString(link.rel),
      onClick: link?.anchor ? (e) => {
        if (customAnchorScroll) {
          return customAnchorScroll(e, link?.anchor);
        }
        const anchorRefId = `viewer-${link?.anchor}`;
        const element = document.getElementById(anchorRefId);
        if (!element) {
          return;
        }
        addAnchorTagToUrl(anchorRefId);
        anchorScroll(element);
      } : void 0
    },
    children
  );
};
export {
  LinkViewerWrapper
};
//# sourceMappingURL=LinkViewerWrapper.js.map
